export default {
  loginEndpoint: '/auth/login',
  loginIntentEndpoint: '/auth/login/intent',
  loginFinalizeEndpoint: '/auth/login/finalize',
  registerEndpoint: '/auth/register',
  refreshEndpoint: '/auth/refresh',
  logoutEndpoint: '/auth/logout',
  factorRecoverEndpoint: '/auth/factor/recover',
  tokenType: 'Bearer',
  storageTokenKeyName: 'accessToken',
  storageRefreshTokenKeyName: 'refreshToken',
  parentAuthMarkerKeyName: 'dikoParentAuth',
}
